import React from "react";
import styles from "./ChallengeCard.module.css";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import dummy from "../../Assets/dummy.png";

function ChallengeCard({ data, countryCode = "in" }) {
  const navigate = useNavigate();

  const handleViewChallenge = (challengeSlug) => {
    navigate(`/challenges/${challengeSlug}`);
  };

  // Calculate discount percentage
  const calculateDiscount = () => {
    const challengeMrp = countryCode === "in" ? data?.mrp : data?.mrp_usd;
    const challengeSellingPrice =
      countryCode === "in" ? data?.selling_price : data?.selling_price_usd;
    if (!challengeMrp || !challengeSellingPrice) return 0;
    return Math.round(
      ((challengeMrp - challengeSellingPrice) / challengeMrp) * 100
    );
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    return `${day} ${month}`;
  };

  // Check if data exists
  if (!data) {
    return null;
  }

  const priceSymbol = countryCode === "in" ? "₹" : "$";
  const challengeSellingPrice =
    countryCode === "in" ? data?.selling_price : data?.selling_price_usd;
  const challengeMrp = countryCode === "in" ? data?.mrp : data?.mrp_usd;
  const discountPercentage = calculateDiscount();

  // Get challenge type badge
  const getChallengeTypeBadge = () => {
    if (data?.challenge_type) {
      return (
        <div className={styles.challengeTypeBadge}>
          {data.challenge_type.charAt(0).toUpperCase() +
            data.challenge_type.slice(1)}
        </div>
      );
    }
    return null;
  };

  // Get category display
  const getCategoryDisplay = () => {
    if (data?.categories && data.categories.length > 0) {
      return data.categories[0].title;
    }
    return "";
  };

  return (
    <div className={styles.card}>
      <div className={styles.imageContainer}>
        <img
          src={data?.hero_image || dummy}
          alt={data?.title || "Challenge"}
          className={styles.cardImage}
        />
        {getChallengeTypeBadge()}

        {data?.total_checkpoints && (
          <div className={styles.checkpointsBadge}>
            {data.total_checkpoints} checkpoints
          </div>
        )}
      </div>

      <div className={styles.cardContent}>
        <div>
          <h2 className={styles.challengeTitle}>{data?.title}</h2>
          <p className={styles.challengeDescription}>
            {data?.hero_title || getCategoryDisplay()}
          </p>
          {data?.enrolments && (
            <p className={styles.enrollments}>{data.enrolments}+ enrolled</p>
          )}
        </div>

        <div className={styles.priceContainer}>
          {data?.selling_price !== "0.00" &&
            data?.selling_price_usd !== "0.00" && (
              <div className={styles.pricingSection}>
                <div className={styles.priceRow}>
                  {discountPercentage > 0 && (
                    <span className={styles.discountBadge}>
                      -{discountPercentage}%
                    </span>
                  )}
                  <span className={styles.currentPrice}>
                    {priceSymbol} {challengeSellingPrice}
                  </span>
                </div>
                {data?.mrp && discountPercentage > 0 && (
                  <span className={styles.originalPrice}>
                    M.R.P: {priceSymbol} {challengeMrp}
                  </span>
                )}
              </div>
            )}

          <div className={styles.buttonContainer}>
            <Button
              variant="contained"
              className={styles.joinNowButton}
              onClick={() => handleViewChallenge(data?.slug)}
            >
              {data?.selling_price !== "0.00" &&
              data?.selling_price_usd !== "0.00"
                ? "Join Challenge"
                : "Join Free"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChallengeCard;
